import React, { useEffect, useState } from 'react';
import { Button, CircularProgress, Divider, LinearProgress, makeStyles } from '@material-ui/core';
import { UserModel } from '../../organisms/UsersTable';
import settings from '../../settings';
import Fetcher, { URLBuild } from '../../services/fetcher';

interface UserModalProps {
  user: UserModel,
  customerId: string
}

const useStyle = makeStyles((theme) => ({
  containerWithDivider: {
    display: 'flex',
    flexDirection: 'row'
  },
  verticalDivider: {
    marginLeft: 10,
    marginRight: 10
  },
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  clickableCustomer: {
    cursor: 'pointer'
  },
  progress: {
    diplay: 'block',
    margin: 'auto'
  },
  billingInfo: {
    marginTop: 4,
    marginBottom: 4
  },
  subscriptionContent: {
    marginLeft: 30
  },
  invoiceButtons: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    '& > *': {
      margin: theme.spacing(1),
    }
  }
}));

function makeAddressElement(oldstr: string, element: string | null): string {
  if (element !== null) {
    if (oldstr.length > 0)
      return oldstr + ', ' + element;
    return element
  }
  return oldstr;
}

function formatDate(datenb: number): string {
  const date: Date = new Date(datenb * 1000);
  const day = ('0' + date.getDate()).substr(-2);
  const month = ('0' + (date.getMonth() + 1)).substr(-2);
  const year = date.getFullYear();
  return day + '-' + month + '-' + year;
}

const UserSub = (props: UserModalProps) => {
  const classes = useStyle();
  const [loading, setLoading] = useState<boolean>(true);
  const [userStripeInformation, setUserStripeInformation] = useState<any | null>(null);
  const [address, setAddress] = useState<string | null>(null);
  const [subscription, setSubscription] = useState<any | null>(null);
  const [schedule, setSchedule] = useState<JSX.Element | null>(null);
  const [scheduleLoading, setScheduleLoading] = useState<boolean>(false);

  useEffect(() => {
    Fetcher.get(
      URLBuild(settings.PaymentProvider.paymentApi + '/stripe/customer/' + props.customerId, {
        'expand': 'subscriptions.data.schedule,subscriptions.data.latest_invoice'
      })
    ).then((user) => {
      setUserStripeInformation(user);
      if (user.address) {
        let tmpAdress = "";
        tmpAdress = makeAddressElement(tmpAdress, user.address.line1);
        tmpAdress = makeAddressElement(tmpAdress, user.address.postal_code);
        tmpAdress = makeAddressElement(tmpAdress, user.address.city);
        tmpAdress = makeAddressElement(tmpAdress, user.address.country);
        if (tmpAdress.length > 0)
          setAddress(tmpAdress)
      }
      if (user.subscriptions && user.subscriptions.total_count === 1) {
        setSubscription(user.subscriptions.data[0])
        if (
          user.subscriptions.data[0].schedule &&
          user.subscriptions.data[0].schedule.phases.length === 3 &&
          user.subscriptions.data[0].schedule.phases[2].items.length === 1
        ) {
          setScheduleLoading(true)
          const priceId = user.subscriptions.data[0].schedule.phases[2].items[0].plan;
          const startDate = user.subscriptions.data[0].schedule.phases[2].start_date;
          Fetcher.get(
            URLBuild(settings.PaymentProvider.paymentApi + '/stripe/prices/' + priceId, {})
          ).then((price: any) => {
            setSchedule((
              <>
                <div>Le : <strong>{formatDate(startDate)}</strong></div>
                <div>Changement d'abonnement vers : <strong>{price.nickname}</strong></div>
              </>
            ));
          }).catch(err =>
            console.error(err)
          ).finally(() => {
            setScheduleLoading(false);
          });
        } else if (user.subscriptions.data[0].cancel_at_period_end) {
          setSchedule(
            <>
              <div>Le : <strong>{formatDate(user.subscriptions.data[0].current_period_end)}</strong></div>
              <div>L'abonnement s'annulera (fin de l'échéance)</div>
            </>
          );
        }
      }
    }).catch(err => {
      console.error(err);
    }).finally(() => {
      setLoading(false);
    });
  }, []);

  const openPdf = (url: string) => {
    window.open(url)
  }

  return (
    <div className={classes.containerWithDivider}>
      <Divider orientation="vertical" flexItem className={classes.verticalDivider}/>
      <div className={classes.container}>
        <h3>Client Stripe <u
          className={classes.clickableCustomer}
          onClick={() => {
            window.open(settings.PaymentProvider.stripeDashboardUrl + 'customers/' + props.customerId, "_blank")
          }}
        >{props.customerId}</u></h3>
        {loading ?
          (
            <div className={classes.progress}>
              <CircularProgress />
            </div>
          ) : userStripeInformation === null ?
            (
              <div>
                <div>Erreur lors du chargement de l'utilisateur stripe</div>
              </div>
            ) : !userStripeInformation.deleted ? (
              <div>
                <div>
                  <div>Information de facturation:</div>
                  <ul className={classes.billingInfo}>
                    <li><strong>{userStripeInformation.name}</strong></li>
                    <li><strong>{userStripeInformation.email}</strong></li>
                    {userStripeInformation.phone && <li><strong>{userStripeInformation.phone}</strong></li>}
                    {address && <li><strong>{address}</strong></li>}
                  </ul>
                </div>
                <br/>
                {subscription &&
                  <div>
                    <div>
                      <div>Abonnement:</div>
                      <div className={classes.subscriptionContent}>
                        <div>Type : <strong>{subscription.plan.nickname}</strong></div>
                        <div>Status : <strong>{subscription.status}</strong></div>
                        <div>Période : Du <strong>{formatDate(subscription.current_period_start)}</strong> au <strong>{formatDate(subscription.current_period_end)}</strong></div>
                      </div>
                    </div>
                    <br/>
                    {scheduleLoading && <LinearProgress />}
                    {schedule &&
                      <div>
                        <div>Action programmée: </div>
                        <div className={classes.subscriptionContent}>
                          {schedule}
                        </div>
                      </div>
                    }
                    <br/>
                    <div className={classes.invoiceButtons}>
                      <Button variant="outlined" color="primary" onClick={() => openPdf(subscription.latest_invoice.invoice_pdf)}>Dernière facture</Button>
                    </div>
                  </div>
                }
              </div>
            ) : (
              <>Cet utilisateur n'existe plus dans la base de données de Stripe.</>
            )
        }
      </div>
    </div>
  );
};

export default UserSub;